import { FunctionComponent, useState } from 'react'
import { IconName } from '../../../shared/interfaces/icon-picker.model'
import { Paper, Stack, Typography } from '@mui/material'
import { IconPicker } from '../display-elements-components/icon-picker'

export const ReductionGroupCard: FunctionComponent<{
  name: string,
  icon: IconName,
  selected?: boolean,
  groupId: string,
  setSelectedGroup: React.Dispatch<React.SetStateAction<any>>,
}> = ({
  name, icon, selected = false, setSelectedGroup, groupId }) => {

    const [hover, setHover] = useState(false);

    return (
      <Paper variant='outlined' sx={{
        p: 1.5, height: '120px', width: '100%', backgroundColor: selected ? 'secondary.light' : 'common.white',
        '&:Hover': { backgroundColor: !selected ? 'lightGrey.light' : 'secondary.light' },
        borderColor: selected ? 'primary' : groupId === 'recommended' ? 'primary.dark' : 'lightGrey.light',
        borderWidth: selected ? '2px' : '1px',
        cursor: 'pointer'
      }}
        onMouseEnter={() => setHover(!selected)}
        onMouseLeave={() => setHover(false)}
        onClick={() => setSelectedGroup(groupId)}
      >
        <Stack display='flex' flexDirection='column' alignItems='center' justifyContent='space-between' sx={{ height: '100%' }}>
          <Stack sx={{ mt: 1 }}>
            <IconPicker icon={icon} color={selected ? 'primary.main' : 'text.primary'} />
          </Stack>
          <Typography sx={{ textAlign: 'center' }}>{name}</Typography>
        </Stack>
      </Paper>
    )
  }